import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { updateProductMasterApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const updateProductMaster = createAsyncThunk('updateProductMaster', async (payload) => {
  return await updateProductMasterApi(payload);
});

const updateProductMasterSlice = createSlice({
  name: 'updateProductMaster', // Unique Name
  initialState,
  reducers: {
    updateProductMasterReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateProductMaster.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(updateProductMaster.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(updateProductMaster.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { updateProductMasterReset } = updateProductMasterSlice.actions;

export default updateProductMasterSlice.reducer;
